// src/i18n/es/summary.ts
// «Resumen» (mockup 05) — route /summary, Dirección.
export const summary = {
  name: 'Resumen |||| Resumen',
  subtitle: 'Cómo llegan y se resuelven las llegadas de los hoteles elegidos',

  tiles: {
    arrivals: 'Llegadas',
    // P02: hotels that do not share their reservation list count Roommatik activity.
    arrivalsRoommatik: 'Reservas con actividad en Roommatik',
    arrivalsMixed: 'Llegadas y reservas con actividad',
    // Arrivals that checked in at the kiosk or on the phone, or took the key
    // from the dispenser. Not the v2 «Resueltas sin recepción» (Operación).
    resolvedWithoutReception: 'Llegadas por autoservicio',
    chargedSelfService: 'Cobrado en autoservicio',
    resolvedWithoutReceptionDetail: '%{count} de %{total} llegada |||| %{count} de %{total} llegadas',
    chargedSelfServiceDetail: '%{count} reserva con cobro |||| %{count} reservas con cobro',
  },

  source: {
    hotelSystem: 'Llegadas según la lista de reservas del hotel, sin canceladas ni no presentados.',
    roommatik:
      'El hotel no comparte su lista de reservas con Roommatik: se cuentan las reservas que han pasado por algún canal de Roommatik, sin incluir a quien lo hizo todo en recepción.',
    mixed:
      'Según la lista de reservas del hotel (sin canceladas ni no presentados): %{hotelSystem}. Reservas con actividad en Roommatik, porque el hotel no comparte su lista: %{roommatik}.',
    mixedCount:
      '%{count} de los %{total} hoteles comparte su lista de reservas: sus llegadas son las de esa lista, sin canceladas ni no presentados. En el resto se cuentan las reservas con actividad en Roommatik. Instalaciones indica el caso de cada hotel. |||| %{count} de los %{total} hoteles comparten su lista de reservas: sus llegadas son las de esa lista, sin canceladas ni no presentados. En el resto se cuentan las reservas con actividad en Roommatik. Instalaciones indica el caso de cada hotel.',
  },

  rows: {
    title: 'Cómo llegaron',
    columns: {
      count: 'Recuento',
      pct: '%',
      previous: 'Periodo anterior',
      chainAvg: 'Media de la cadena',
      // The chain average is a share only; in the count view the header says so.
      chainAvgShare: 'Media de la cadena (%)',
    },
    arrivals: 'Llegadas',
    invited: 'Invitadas',
    preCheckInDone: 'Pre-check-in hecho',
    preCheckInPartial: 'Pre-check-in a medias',
    keyWithoutReception: 'Por autoservicio (kiosco, móvil o dispensador)',
    airLobby: 'Air Lobby',
    kioskWithoutPreCheckIn: 'Kiosco o móvil sin pre-check-in',
    noRecord: 'Sin check-in registrado',
    availableSoon: 'Disponible próximamente',
  },

  view: {
    count: 'Recuento',
    pct: '%',
  },

  byDay: {
    title: 'Llegadas por día',
    description: 'Cada llegada aparece en una sola serie, por este orden: Air Lobby, pre-check-in hecho, kiosco o móvil, otro canal; sin nada, según el día ya esté cerrado o no.',
    series: {
      withPreCheckIn: 'Con pre-check-in',
      kioskWithoutPreCheckIn: 'Kiosco o móvil sin pre-check-in',
      airLobby: 'Air Lobby',
      otherCheckIn: 'Check-in en otro canal',
      noRecord: 'Sin pre-check-in ni check-in',
      pending: 'Pendientes (día en curso)',
    },
  },

  checkInByChannel: {
    title: 'Check-in por canal',
    other: 'Otros canales',
    columns: {
      channel: 'Canal',
      checkIns: 'Check-ins',
      pctOfArrivals: '% de llegadas',
      withPreCheckIn: 'Con pre-check-in',
      medianSeconds: 'Duración mediana',
      keysDelivered: 'Llaves entregadas',
      charged: 'Cobrado en el canal',
    },
  },

  noRecord: {
    line:
      '%{count} llegada sin check-in registrado (%{pct} de las llegadas de días ya cerrados) |||| %{count} llegadas sin check-in registrado (%{pct} de las llegadas de días ya cerrados)',
  },

  estimatedArrivalDates: 'Fecha de llegada estimada en %{count} reserva |||| Fecha de llegada estimada en %{count} reservas',

  export: {
    row: 'Concepto',
  },

  help: {
    title: 'Resumen',
    description:
      'La vista de conjunto de las llegadas de los hoteles elegidos: cuántas hubo, cómo se resolvieron y qué canal usaron para el check-in.',
    features: {
      source:
        'Si el hotel comparte su lista de reservas, «Llegadas» son las de esa lista, sin canceladas ni no presentados; si no, se cuentan las reservas con actividad en Roommatik. La nota bajo las cifras indica cuál se aplica a cada hotel.',
      rows: 'La tabla «Cómo llegaron» compara el periodo con el anterior y, si procede, con la media de la cadena.',
      byDay: 'El gráfico por día reparte cada llegada en una sola serie; los días sin llegadas aparecen a cero.',
      channel: 'El check-in por canal indica cuántas llegadas se resolvieron en cada canal y en cuánto tiempo; «Otros canales» recoge el resto, de modo que las filas suman las llegadas con check-in.',
      selfService: '«Llegadas por autoservicio» cuenta las llegadas con check-in en el kiosco o en el móvil, o con la llave recogida en el dispensador. Su variación se da en puntos porcentuales (pp).',
      noRecord:
        '«Sin check-in registrado» solo cuenta días ya cerrados, y su porcentaje es sobre las llegadas de esos días: las del día en curso no cuentan hasta que el hotel cierra su jornada (normalmente a las 04:00).',
    },
    tips: {
      compare: 'Active «Comparar con el periodo anterior» para ver la evolución.',
    },
  },
};

export default summary;
